// export const FUEL_TYPE=[
//     "Diesel", "Petrol", "Petrol + Electricity", "Electricity", "Methane", "Other"
// ]

// export const TRANSPORT_TYPE=["Sent by supplier (vehicle)" , "Sent by Air mail",  "Fetched by the Company (vehicle)",  "Fetched by Transport Company (vehicle)"]

// export const MATERIAL_TYPE=[ "Paper", "Plastic & Foam", "Glass", "Metal", "Timber", "Other"]
export const FUEL_TYPE = [
  "diesel",
  "petrol",
  "petrol_electricity",
  "electricity",
  "methane",
  "other",
];

export const TRANSPORT_TYPE = [
  "sent_by_supplier",
  "sent_by_airmail",
  "sent_by_ship",
  "sent_by_train",
  "fetched_by_company",
  "fetched_by_transport_company",
];

export const MATERIAL_TYPE = [
  "paper",
  "plastic_foam",
  "glass",
  "metal",
  "timber",
  "other",
];
